import { Component, Vue } from 'vue-property-decorator'

@Component
export default class Contact extends Vue {
  countries = [
    { code: 'fr', phoneNumber: '+33 1 84 80 80 81' },
    { code: 'de', phoneNumber: '+32 2 896 50 13  ' },
    { code: 'ch', phoneNumber: '+41 22 596 48 40 ' },
    { code: 'us', phoneNumber: '+1 415 680 3066  ' },
    { code: 'lu', phoneNumber: '+352 20 88 10 75 ' },
    { code: 'pt', phoneNumber: '+351 21 122 7760 ' },
    { code: 'gb', phoneNumber: '+44 20 3890 6663 ' },
    { code: 'ie', phoneNumber: '+353 1 571 9090  ' },
    { code: 'it', phoneNumber: '+39 02 8731 7399 ' },
    { code: 'ca', phoneNumber: '+1 647 243 8121  ' },
    { code: 'be', phoneNumber: '+32 2 896 50 13  ' },
    { code: 'au', phoneNumber: '+61 2 8310 6519  ' },
    { code: 'es', phoneNumber: '+34 910 38 22 69 ' },
    { code: 'hk', phoneNumber: '+852 5808 2016   ' },
    { code: 'sg', phoneNumber: '+65 3158 0825    ' },
    { code: 'br', phoneNumber: '+55 21 3500 1311 ' },
    { code: 'mx', phoneNumber: '+52 55 5350 5497' },
  ]

  get supportMail(): string {
    return process.env.VUE_APP_SUPPORT_MAIL
  }

  get supportMailLink(): string {
    return `mailto:${this.supportMail}`
  }

  get salesMail(): string {
    return process.env.VUE_APP_SALES_MAIL
  }

  get supportSalesLink(): string {
    return `mailto:${this.salesMail}`
  }

  get supportPhoneNumber(): string {
    return this.countries.filter((country) => country.code === 'fr')[0].phoneNumber
  }

  get supportPhoneNumberLink(): string {
    return `tel:${this.supportPhoneNumber}`
  }
}
